/**
 * @desc Yung-创建出库单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.OutMasterCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outMaster/createOutMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
